import React, { useMemo } from 'react';

import { Box } from '@chakra-ui/react';
import { MyDataDisciplinaryActionsGrid } from 'Deer/pages/MyData/DisciplinaryActions/MyDataDisciplinaryActionsGrid';
import { useSelectedView } from 'reducers/viewsSlice';
import { checkNewNavEnabled } from 'utils/helpers/featureFlags';

import { MODULE_KEYS } from 'constants/ProjectConstants';
import { getPersistenceKey } from 'constants/helper';

import { useSelectDisciplinaryActionsSelectedIntent } from './slice/DisciplinaryActionsIntentSlice';

function MyDataDisciplinaryActionsIntent({ gridRef, intentId = null }) {
  const cohortDetails = useSelectedView();
  const { id } = useSelectDisciplinaryActionsSelectedIntent() || {};

  /* Grid State persistence Key */
  const viewId = cohortDetails?.id;
  const gridStatePersistenceKey = useMemo(() => {
    const uniqueId = 'MyDataDisciplinaryActionsGrid';

    return getPersistenceKey({
      moduleName: MODULE_KEYS.DISCIPLINARY_ACTIONS,
      viewId,
      tabId: '',
      uniqueId,
    });
  }, [viewId]);

  return (
    <Box position="relative">
      <Box p={!checkNewNavEnabled() ? 3 : 0}>
        <MyDataDisciplinaryActionsGrid
          gridRef={gridRef}
          gridStatePersistenceKey={gridStatePersistenceKey}
          intentId={intentId ?? id}
        />
      </Box>
    </Box>
  );
}

export { MyDataDisciplinaryActionsIntent };
